module.exports = __webpack_public_path__ + "img/folderacc.86004d35.png";